import DescriptionIcon from '@material-ui/icons/Description';
import { QuotedMessage } from '@src/types';
import { useIntl } from 'react-intl';

type ChatMessageFileQuotedProps = {
  title: React.ReactNode;
  message: QuotedMessage;
};

const ChatMessageFileQuoted: React.FC<ChatMessageFileQuotedProps> = ({
  title,
  message,
}) => {
  const intl = useIntl();
  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      {title}
      <div className="ChatMessageContentQuoted">
        <DescriptionIcon style={{ marginRight: 3 }} />
        {message?.text?.length
          ? message.text
          : intl.formatMessage({ id: 'AgentChatTimeline.file.text' })}
      </div>
    </div>
  );
};

export default ChatMessageFileQuoted;
